import { v2Client } from '@api/apiClient'
import { useQuery } from '@tanstack/react-query'

type SystemStatusResponse = {
  status: 'ok' | 'error'
}

export const useGetSystemStatus = () => {
  return useQuery({
    queryKey: ['system-status'],
    queryFn: () => v2Client.get<SystemStatusResponse>('/health'),
    select: (data) => data.data,
    refetchInterval: 60000,
  })
}
